export const MAX_MESSAGE_LENGTH = 1000;
